import { TypeDefaultImage } from "@/lib/image";
import { ColumnDef } from "@tanstack/react-table";

export const ACTIONS_COLUMN_ID = "actions";

export function ensureActionsColumnLast(order: string[]): string[] {
  const without = order.filter((key) => key !== ACTIONS_COLUMN_ID);
  return [...without, ACTIONS_COLUMN_ID];
}

export function getResourceEditPath(
  resourceType: TypeDefaultImage | string,
  resourceId: string,
): string {
  return `/edit/${resourceType}/${resourceId}`;
}

export function createActionsColumnDef<T = unknown>(
  cell: ColumnDef<T, unknown>["cell"],
  options?: { size?: number; id?: string },
): ColumnDef<T, unknown> {
  const columnId = options?.id ?? ACTIONS_COLUMN_ID;

  return {
    id: columnId,
    accessorKey: columnId,
    meta: { isActionColumn: true },
    header: "",
    size: options?.size ?? 56,
    enableHiding: false,
    enableSorting: false,
    cell,
  };
}
